import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Plus } from 'lucide-react';
import { Button } from '@/shared/components/ui/button';
import { Input } from '@/shared/components/ui/input';
import { createChecklistNameSchema } from '../schemas';

interface AddChecklistInlineProps {
  onCreate: (name: string) => void;
}

export function AddChecklistInline({ onCreate }: AddChecklistInlineProps) {
  const { t } = useTranslation('checklists');
  const [adding, setAdding] = useState(false);
  const [draft, setDraft] = useState('');

  function commit() {
    const parsed = createChecklistNameSchema(t).safeParse(draft);
    if (parsed.success) {
      onCreate(parsed.data);
      setDraft('');
      setAdding(false);
    }
  }

  if (!adding) {
    return (
      <Button
        variant="ghost"
        size="sm"
        className="w-full justify-start text-muted-foreground"
        onClick={() => setAdding(true)}
        data-testid="checklists-add-checklist-btn"
      >
        <Plus className="mr-1.5 size-4" />
        {t('section.addChecklist')}
      </Button>
    );
  }

  return (
    <Input
      autoFocus
      value={draft}
      onChange={(e) => setDraft(e.target.value)}
      onBlur={() => {
        if (draft.trim()) commit();
        else setAdding(false);
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter') commit();
        else if (e.key === 'Escape') {
          setDraft('');
          setAdding(false);
        }
      }}
      placeholder={t('checklist.namePlaceholder')}
      aria-label={t('section.addChecklist')}
      className="h-8 text-sm"
      data-testid="checklists-add-checklist-input"
    />
  );
}
